import { useMediaQuery } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

// sm: "480px",
// md: "768px",
// lg: "992px",
// xl: "1280px",
// "2xl": "1536px",

interface IScreenState {
  isSmallMobile: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isLargeTablet: boolean;
  isDesktop: boolean;
}

export default function useScreen(): IScreenState {
  const [isSmallMobile] = useMediaQuery('(max-width: 320px)');
  const [isTablet] = useMediaQuery('(min-width: 480px)');
  const [isLargeTablet] = useMediaQuery('(min-width: 768px)');
  const [isDesktop] = useMediaQuery('(min-width: 992px)');

  const [ready, setReady] = useState(false);

  // fix for ssr, while not rendered yet return as desktop
  useEffect(() => setReady(true), []);

  return {
    isSmallMobile: ready && isSmallMobile,
    isMobile: ready && !isTablet && !isDesktop,
    isLargeTablet: ready && isLargeTablet && !isDesktop,
    isTablet: ready && isTablet && !isDesktop,
    isDesktop: ready && isDesktop,
  };
}
